import { Home, Leaf, HeartHandshake, Timer } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function ResidentialPestControl() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Residential Pest Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        Keep your family safe from cockroaches, termites, bed bugs, rodents and mosquitoes with our professional residential pest control services.
                    </p>
                    <p className="chimney-repair-subtitle">
                        We focus more on preventive measures rather than curative measures, so your home stays clean, healthy and pest free.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Our services are convenient - treatments can be executed without any disturbance to the routine work in your house.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Book a free inspection and get a professional, eco-friendly and cost effective solution for your home.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="Residential Pest Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Residential Service?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Family Safe</h3>
                            <p className="chimney-repair-description">
                                Environmentally safe active ingredients, safe for children and pets.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <HeartHandshake size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">No Disturbance</h3>
                            <p className="chimney-repair-description">
                                Treatment executed without any disturbance to your daily routine.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Leaf size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Preventive Focus</h3>
                            <p className="chimney-repair-description">
                                Preventive measures rather than curative for lasting protection.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Timer size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Quick Resolution</h3>
                            <p className="chimney-repair-description">
                                Quick resolution of your every query, promptly and professionally.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Residential Pest Control Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Free Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Free inspection of your home to identify pest activity and risk areas.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Custom Plan</h3>
                        <p className="chimney-repair-step-description">
                            A treatment plan designed for the pests and layout of your home.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Treatment</h3>
                        <p className="chimney-repair-step-description">
                            Eco-friendly treatment by trained, experienced staff at your convenience.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Support</h3>
                        <p className="chimney-repair-step-description">
                            Pre and post service guidance with quick resolution of all your queries.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default ResidentialPestControl;